/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var select2: any;
namespace Nobox.CRM {
    
    @Serenity.Decorators.registerClass()
    export class GroupExcelImportDialog extends NoboxEntityDialog<any, any> {
        protected form = new GroupExcelImportForm(this.idPrefix);
        public grid: any;

        constructor() {
            super();
        }

        protected updateTitle(): void {
            super.updateTitle();
        }

        dialogOpen() {
            super.dialogOpen();
            $(".s-NoBoxCRM-NoBoxCRM-GroupExcelImportDialog").children("div.ui-dialog-titlebar").find("span.ui-dialog-title").text("Import Excel & CSV");
            Q.Router.replace("");
        }

        protected getToolbarButtons() {
            var buttons = super.getToolbarButtons();

            buttons = [];
            buttons.push({
                title: 'Download Template',
                hint: 'Download Template',
                separator: true,
                icon: "fa-download text-green",
                onClick: () => {
                    window.open(`${Q.resolveUrl('~/upload/Template/') + 'CompanyTemplate.xlsx'}`)
                }
            });
            return buttons;
        }

        protected getDialogButtons() {
            var $this = this;
            var buttons = super.getDialogButtons();
            return [
                {
                    text: 'Import',
                    click: () => {
                        if (!this.validateBeforeSave())
                            return;

                        if (this.form.FileName.value == null ||
                            Q.isEmptyOrNull(this.form.FileName.value.Filename)) {
                            Q.notifyError("Please select a file!");
                            return;
                        }

                        ExcelImportService.ExcelImport({
                            FileName: this.form.FileName.value.Filename
                        }, response => {
                            //Q.notifyInfo(
                            //    'Inserted: ' + (response.Inserted || 0) +
                            //    ', Updated: ' + (response.Updated || 0));
                            if (response.ErrorList != null && response.ErrorList.length > 0) {
                                Q.notifyError(response.ErrorList.join(',\r\n '));
                            }

                            this.dialogClose();

                            function getColumns() {
                                return new Promise(resolve => {
                                    $.get(window.location.origin + '/Services/Lead/GroupImportExcel/GroupListColumns', resolve);
                                });
                            };

                            getColumns()
                                .then(result => {
                                    //$('#modalImportExcel').modal('show');
                                    var dlg = new NoBoxCRM.GroupExcelDialog();
                                    dlg.dialogOpen();
                                    const data = response.data;
                                    var arrTotalDropdown = [];
                                    var arrAddress = ["address", "alamat", "place"];
                                    var arrCity = ["city", "kota", "kab/kota", "kab", "kabupaten"];
                                    var arrCountry = ["country", "negara"];
                                    var arrEmail = ["email", "mail", "gmail","e-mail"];
                                    var arrExtId = ["id", "extid", "code", "kode", "external id", "nik", "nis", "nisn"];
                                    var arrName = ["name", "full name", "title", "nama", "nama lengkap","first name"];
                                    var arrNotes = ["note", "notes", "catatan"];
                                    var arrPhone = ["phone", "phone number", "telephone", "telepon", "tlp", "no hp", "nohp", "no wa", "nowa", "nomor whatsapp", "nomor wa", "no whatsapp", "whatsapp"];
                                    var arrPostal = ["postal", "kode pos", "zip code", "zipcode"];
                                    var arrState = ["state", "province", "provinsi", "states"];


                                    let keys;
                                    let head = '';
                                    let head2 = '<tr>';
                                    let body = '';
                                    var indexSelected = [];
                                    for (let i = 0; i < data.length; i++) {
                                        let count = 0;
                                        keys = Object.keys(data[i]);
                                        head += '<tr>';
                                        keys.forEach((key, ind) => {
                                            if (i == 0) {
                                                if (count >= 0) {
                                                    const fields = result['Values'];
                                                    arrTotalDropdown.push(count);
                                                    head += '<th><select class="select-field form-input" id="f' + count + '">';
                                                    head += '<option style="color: red" value="0">Not Imported</option>'
                                                    fields.sort((a,b)=>b-a).forEach((field, index) => {
                                                        if (field.Field == "Id" || field.Field == "ListId" || field.Field == "Tags" || field.Field == "Unik" || field.Field == "Progress" || field.Field == "In" || field.Field == "Up" || field.Field == "InBy" || field.Field == "UpBy" || field.Field == "TnId" || field.Field == "Status" || field.Field == "OwnerId" || field.Field == "DealIds" || field.Field == "TaskIds" || field.Field == "Document" || field.Field == "AddressMap" || field.Field == "GroupId") {

                                                        } else {
                                                            head += '<option>' + field.Field + '</option>'
                                                        }
                                                    })
                                                    head += '</th></select>';
                                                } else {
                                                    head += '<th></th>';
                                                }
                                                var keyFinal = key.toLowerCase();
                                                if (arrName.indexOf(keyFinal)>=0) {
                                                    indexSelected.push({ ind1: 7, ind2: ind });
                                                } else if (arrPhone.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 9, ind2: ind });
                                                } else if (arrEmail.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 4, ind2: ind });
                                                } else if (arrAddress.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 1, ind2: ind });
                                                } else if (arrCountry.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 3, ind2: ind });
                                                } else if (arrState.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 11, ind2: ind });
                                                } else if (arrCity.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 2, ind2: ind });
                                                }else if (arrExtId.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 5, ind2: ind });
                                                }else if (arrNotes.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 8, ind2: ind });
                                                } else if (arrPostal.indexOf(keyFinal) >= 0) {
                                                    indexSelected.push({ ind1: 12, ind2: ind });
                                                }
                                                head2 += '<th style="background:#005fb1; color:white;"> ' + key + '</th>';
                                            }
                                            data[i][key] == "null" ? "" : data[i][key];
                                            if (i <= 49) {
                                                if (count == 0)
                                                    body += '<tr>';
                                                body += '<td>' + data[i][key] + '</td>' == '<td>null</td>' ? '<td></td>' : '<td>' + data[i][key] + '</td>';

                                                if (count == data[i].length - 1)
                                                    body += '</tr>';
                                            }

                                            count++;
                                        });
                                        head += '</tr>';
                                    }
                                    head2 += '</tr>';
                                    var arrFilter = [null]
                                    $('#table').removeClass('hide');
                                    $('#thead1').append(head);
                                    if (indexSelected.length) {
                                        indexSelected.forEach((a, b) => {
                                            jQuery("#f" + a.ind2).find("option:eq(" + a.ind1 + ")").attr("selected", "true");
                                            arrFilter[a.ind2] = $('#f' + a.ind2).val();
                                        })
                                    }
                                    $('#thead2').append(head2);
                                    $('tbody').append(body);
                                    $('#totalData').text(`Total: ${data.length} Data`);
                                    $('.select-field').select2();
                                    arrTotalDropdown.forEach(function (r) {
                                        $('#f' + r).change(function () {
                                            arrFilter[r] = $('#f' + r).val();
                                        })
                                    })
                                    dlg.callback = (hasil) => {
                                        hasil = JSON.parse(hasil);
                                        const filterFields = arrFilter;
                                        if (filterFields.indexOf("Name") < 0) {
                                            Q.alert("Please import 'Name' field.");
                                        }else if (filterFields.indexOf("ExtId") < 0 && hasil.GenerateId == false) {
                                            Q.alert("Please import 'External Id' field or check the 'Generate External Id'.");
                                        } else {
                                            let dataToStore = [];
                                            for (let i = 0; i < data.length; i++) {
                                                keys = Object.keys(data[i]);
                                                let dataToPush = {
                                                    "Name": "",
                                                    "Telephone": "",
                                                    "ListId": hasil.ListId,
                                                    
                                                    "Status": hasil.Status,
                                                   
                                                    "OwnerId": hasil.OwnerId,
                                                    "Source": hasil.Source,
                                                    "Country": hasil.Country,
                                                    "State": "",
                                                    "City": "",
                                                    "ZipCode": "",
                                                    "Address": "",
                                                }
                                                let x = 0
                                                keys.forEach(key => {
                                                    if (filterFields[x] != null) {
                                                        if (filterFields[x] != "0")
                                                            dataToPush[filterFields[x]] = data[i][key];
                                                    }

                                                    x++;
                                                })

                                                dataToStore.push({ Entity: dataToPush });
                                            }
                                            $(".CancelImport").addClass("disabled");
                                            Q.serviceCall({
                                                blockUI: true,
                                                url: "/Services/Nobox/Groups/Save",
                                                request: dataToStore,
                                                onSuccess: (res) => {
                                                    dlg.dialogClose();
                                                    $this.grid.refresh();
                                                    Q.notifySuccess(`Success add ${res.CustomData.Insert} data & update ${res.CustomData.Update} data to database`);
                                                }
                                            });
                                        }
                                    }
                                });
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }
    }
}